export const gwColors = {
  black: '#000',
  evergreen: '#557262',
  grayMedium: '#7F7F7F',
  links: '#0766C1',
  textPrimary: '#454545',
  uiDivider: '#dfe5e8',
}
